import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

// Inject ENV_TOKEN automatically on all openApi requests
openApi.interceptors.request.use((config) => {
	const token = process.env.REACT_APP_ENV_TOKEN;
	if (token) {
		config.params = { ...config.params, token };
	}
	return config;
});

export default api;
